
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import MessageStatusMC from './MessageStatusMC';
import IconMC from '../../../components/IconMC';
import OptionsListModalMC from './OptionsListModalMC';
import useListMessageUI from '../../../hooks/inbox/ui/useListMessageUI';
import useListMessageData from '../../../hooks/inbox/data/useListMessageData';

const ListMessageMC = memo(({ conversation, message }) => {
  const { t } = useTranslation('InboxMC');
  const { isOpen, toggleModal, closeModal } = useListMessageUI();
  const { messageText, options, optionTitle, listTitle } = useListMessageData(message);

  return (
    <div className="tw-wrapper">
      <div className="tw-mb-1 tw-text-base tw-font-semibold tw-text-[#3CAAE1]">
        {listTitle}
      </div>
      <div className="tw-whitespace-pre-line tw-text-3xs md:tw-text-xs tw-mb-2">
        <div dangerouslySetInnerHTML={{ __html: messageText }} />
        <MessageStatusMC message={message} platform={conversation.platform} />
      </div>
      <div className="tw-flex tw-justify-center tw-p-3">
        <button
          type="button"
          className="tw-bg-white tw-border-none tw-rounded-xl tw-px-2 tw-py-2 tw-w-full tw-text-[#3CAAE1] tw-flex tw-items-center tw-justify-center hover:tw-bg-blue-50 focus:tw-outline-none"
          onClick={toggleModal}
        >
          <IconMC name="bulleted-list" size="lg" className="tw-mr-1" />
          <span className="tw-text-sm tw-font-normal">
            {optionTitle || t('listMessage.defaultOptionTitle')}
          </span>
        </button>
        {isOpen && (
          <OptionsListModalMC
            isOpen={isOpen}
            toggleModal={closeModal}
            options={options}
            optionTitle={optionTitle || t('listMessage.defaultOptionTitle')}
          />
        )}
      </div>
    </div>
  );
});

ListMessageMC.displayName = 'ListMessageMC';

export default ListMessageMC;